import React, { FC, useContext } from "react";
import { useSelector } from "react-redux";
import { GeometryType } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { Controls } from "../../styled";
import { FeatureCardContext } from "./FeatureCardContext";
import { ToggleRastersIcon } from "../ToggleRastersIcon/ToggleRastersIcon";
import { EditControls } from "../Controls/EditControls";
import { DefaultControls } from "../Controls/DefaultControls";
import { HandBookControls } from "../Controls/HandBookControls";
import { CopyIconButton } from "../Controls/styled";

import { useCopyFeatureDialog } from "../../../../hooks/useDialogs";
import { getPreviousFeatureReference } from "../../../../ducks/showFeature/selectors";

export const FeatureCardControls: FC = () => {
  const { t } = useTranslation("common");
  const openCopyFeatureDialog = useCopyFeatureDialog();

  const {
    attributes,
    feature,
    layerInfo,
    coordinates,
    handBookReference,
    geometryType,
    isEdit,
    isRaster,
    isFeatureEditable,
    editOnly,
    hasCopyRights,
    closeCard,
    toggleEditMode,
    saveAttributes,
  } = useContext(FeatureCardContext);

  const previousFeatureReference = useSelector(getPreviousFeatureReference);
  const hasGeometry = geometryType !== GeometryType.Unknown && !!coordinates;
  const hasControls = isRaster || isFeatureEditable || (hasCopyRights && hasGeometry);

  if (layerInfo.type === "ProxyService") {
    return (
      <Controls>
        <CopyIconButton kind={"copy"} title={t("actions.copy")} onClick={() => openCopyFeatureDialog()} />
      </Controls>
    );
  }

  return (
    <>
      {layerInfo?.layerDefinition?.isEditable &&
        !layerInfo?.name.startsWith("temp") &&
        !handBookReference &&
        hasControls && (
          <Controls>
            {isRaster && <ToggleRastersIcon feature={feature} />}
            {isFeatureEditable ? (
              <>
                {isEdit || editOnly ? (
                  <EditControls
                    feature={feature}
                    isRaster={isRaster}
                    geometryType={geometryType as GeometryType}
                    toggleEditMode={editOnly ? closeCard : toggleEditMode}
                    saveChanges={saveAttributes}
                  />
                ) : (
                  <DefaultControls toggleEditMode={toggleEditMode} hasEditRights />
                )}
              </>
            ) : (
              <DefaultControls hasCopyRights={hasCopyRights && hasGeometry} />
            )}
          </Controls>
        )}
      {handBookReference && (
        <HandBookControls
          layerReference={handBookReference}
          attributes={attributes}
          feature={feature}
          previousFeatureReference={previousFeatureReference}
        />
      )}
    </>
  );
};
